// chakra imports
import { Box, Flex, Stack } from '@chakra-ui/react';
//   Custom components
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import SidebarCard from 'components/sidebar/components/SidebarCard';
import React from 'react';

// FUNCTIONS

function SidebarContent(props) {
  const { routes} = props;
  // SIDEBAR
  return (
    <Flex
      direction='column'
      height='100%'
      
      className='sidebar-main'
    >
      <Brand />
      <Stack direction='column' mb='auto' mt={5}  height='100%'>
        <Box ps='3px'  height='100%'>
          <Links routes={routes} />
        </Box>
      </Stack>

      <Box mt='30px' mb='50px' borderRadius='30px'>
        <SidebarCard />
      </Box>
      
    </Flex>
  );
}

export default SidebarContent;
